import React from 'react';
import Datatable from 'src/common/refactoredComponents/dataTable/DataTable';
import { AdjustmentProductContainer } from 'src/common/components/orderDetails/subItemsDatatable/SubItemsDatatable.styled';
import CfnLabel from 'src/common/components/orderDetails/bundleCards/CfnLabel';
import SerialNoLabel from 'src/common/components/orderDetails/bundleCards/SerialNoLabel';
import ItemDescriptionLabel from 'src/common/components/orderDetails/bundleCards/ItemDescriptionLabel';
import QuantityContainer from 'src/common/components/orderDetails/bundleCards/QuantityContiner';

const SubItemDatatable = ({ colDatas, rowDatas, setItemHandler, isEquity }) => {
    colDatas = colDatas?.map((column) => {
        const extraProps = {
            bodyStyle: {},
        };
        switch (column.field) {
            case 'subItemsDescription':
                extraProps.headerStyle = {
                    padding: '0px 0px 0px 10px',
                    width: '65%',
                    height: '42px',
                };
                extraProps.bodyStyle = {
                    width: '65%',
                    margin: '10px 0 0 0',
                    padding: '0px 0px 0px 10px',
                    height: '65px',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <AdjustmentProductContainer
                                margin={'10px 0 0 0'}
                                flexDirection={'column'}
                                justifyContent={'flex-start'}
                            >
                                <CfnLabel
                                    setItemHandler={setItemHandler}
                                    setDetailsData={rowData}
                                    cfn={rowData.cfn}
                                    isShowSetItemDetails={true}
                                    isEquity={isEquity}
                                />
                                <SerialNoLabel serialNo={rowData.serialNo} />

                                <ItemDescriptionLabel
                                    description={rowData.description}
                                />
                            </AdjustmentProductContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            case 'quantity':
                extraProps.headerStyle = {
                    width: '35%',
                    textAlign: 'right',
                    padding: '0 4% 0 0',
                    height: '42px',
                };
                extraProps.bodyStyle = {
                    width: '35%',
                    margin: '10px 0 0 0',
                    padding: '0px 10px 0px 0px',
                    height: '65px',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <AdjustmentProductContainer
                                justifyContent={'flex-end'}
                                margin={'10px 0 0 0'}
                                alignItems={'flex-start'}
                            >
                                <QuantityContainer
                                    quantity={
                                        rowData?.quantity
                                            ? rowData.quantity
                                            : null
                                    }
                                    isShowUom={true}
                                    showLabel={false}
                                />
                            </AdjustmentProductContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            default:
                return {
                    ...column,
                    ...extraProps,
                };
        }
    });

    return (
        <>
            <Datatable
                id={'orderDetails-subItemsDatatable'}
                backgroundColorOdd={'#F5F5F599'}
                backgroundColorEven={'#FFFFFF99'}
                resizableColumns
                columns={colDatas}
                data={rowDatas}
            />
        </>
    );
};

export default SubItemDatatable;
